// Catalogul și selectorii componentelor unui control sunt partajați de editor și de FormControl.
// Cheile sunt persistente în CtlProps.ComponentClasses; etichetele vin din FormLayoutResources.
const COMMON_COMPONENTS = [
    { id: 'wrapper', labelKey: 'ComponentClass_Wrapper', selector: 'wrapper' },
    { id: 'labelRow', labelKey: 'ComponentClass_LabelRow', selector: 'labelRow' },
    { id: 'label', labelKey: 'ComponentClass_Label', selector: 'label' },
    { id: 'labelActions', labelKey: 'ComponentClass_LabelActions', selector: 'labelActions' },
    { id: 'description', labelKey: 'ComponentClass_Description', selector: 'description' },
    { id: 'validation', labelKey: 'ComponentClass_Validation', selector: 'validation' },
    { id: 'controlRow', labelKey: 'ComponentClass_ControlRow', selector: 'controlRow' },
    { id: 'controlActions', labelKey: 'ComponentClass_ControlActions', selector: 'controlActions' }
];

const CONTROL_COMPONENTS = {
    Switch: [
        { id: 'control', labelKey: 'ComponentClass_Switch', selector: 'switch' },
        { id: 'switchTrack', labelKey: 'ComponentClass_SwitchTrack', selector: '.k-switch-container' },
        { id: 'switchHandle', labelKey: 'ComponentClass_SwitchHandle', selector: '.k-switch-handle' },
        { id: 'switchOnLabel', labelKey: 'ComponentClass_SwitchOnLabel', selector: '.k-switch-label-on' },
        { id: 'switchOffLabel', labelKey: 'ComponentClass_SwitchOffLabel', selector: '.k-switch-label-off' }
    ],
    Checkbox: [
        { id: 'control', labelKey: 'ComponentClass_Checkbox', selector: 'control' }
    ],
    IntegerTextBox: [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' },
        { id: 'inputWrapper', labelKey: 'ComponentClass_InputWrapper', selector: '.k-numerictextbox' },
        { id: 'spinButtons', labelKey: 'ComponentClass_SpinButtons', selector: '.k-spinner-increase, .k-spinner-decrease' }
    ],
    NumericTextBox: [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' },
        { id: 'inputWrapper', labelKey: 'ComponentClass_InputWrapper', selector: '.k-numerictextbox' },
        { id: 'spinButtons', labelKey: 'ComponentClass_SpinButtons', selector: '.k-spinner-increase, .k-spinner-decrease' }
    ],
    TextBox: [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' }
    ],
    TextArea: [
        { id: 'control', labelKey: 'ComponentClass_TextArea', selector: 'control' }
    ],
    Html: [
        { id: 'control', labelKey: 'ComponentClass_Editor', selector: '.k-editor' },
        { id: 'editorToolbar', labelKey: 'ComponentClass_EditorToolbar', selector: '.k-editor-toolbar' },
        { id: 'editorContent', labelKey: 'ComponentClass_EditorContent', selector: '.k-editable-area' }
    ],
    RichText: [
        { id: 'control', labelKey: 'ComponentClass_Editor', selector: '.k-editor' },
        { id: 'editorToolbar', labelKey: 'ComponentClass_EditorToolbar', selector: '.k-editor-toolbar' },
        { id: 'editorContent', labelKey: 'ComponentClass_EditorContent', selector: '.k-editable-area' }
    ],
    DatePicker: [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' },
        { id: 'inputWrapper', labelKey: 'ComponentClass_InputWrapper', selector: '.k-datepicker' },
        { id: 'pickerButton', labelKey: 'ComponentClass_PickerButton', selector: '.k-datepicker .k-input-button' }
    ],
    DateTimePicker: [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' },
        { id: 'inputWrapper', labelKey: 'ComponentClass_InputWrapper', selector: '.k-datetimepicker' },
        { id: 'pickerButton', labelKey: 'ComponentClass_PickerButton', selector: '.k-datetimepicker .k-input-button' }
    ],
    ComboBox: [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: '.k-combobox' },
        { id: 'input', labelKey: 'ComponentClass_Input', selector: '.k-input-inner' },
        { id: 'dropdownButton', labelKey: 'ComponentClass_DropdownButton', selector: '.k-input-button' },
        { id: 'listItem', labelKey: 'ComponentClass_ListItem', selector: '.k-list-item' }
    ],
    GeomPicker: [
        { id: 'control', labelKey: 'ComponentClass_MapControl', selector: 'control' },
        { id: 'map', labelKey: 'ComponentClass_Map', selector: '.xp-map-container' }
    ],
    File: [
        { id: 'control', labelKey: 'ComponentClass_FileDropzone', selector: 'control' },
        { id: 'uploadMessage', labelKey: 'ComponentClass_FileMessage', selector: '.dz-message' },
        { id: 'uploadIcon', labelKey: 'ComponentClass_FileIcon', selector: '[id$="-img"]' },
        { id: 'uploadHint', labelKey: 'ComponentClass_FileHint', selector: '[id$="-label"]' },
        { id: 'filePreview', labelKey: 'ComponentClass_FilePreview', selector: '.dz-preview' },
        { id: 'filePreviewImage', labelKey: 'ComponentClass_FilePreviewImage', selector: '.dz-image' },
        { id: 'fileName', labelKey: 'ComponentClass_FileName', selector: '.dz-filename' },
        { id: 'removeFileButton', labelKey: 'ComponentClass_FileRemoveButton', selector: '.dz-remove, .btn-delete' }
    ]
};

const SUBTYPE_COMPONENTS = {
    'ComboBox.ListView': [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: 'control' },
        { id: 'selectionImage', labelKey: 'ComponentClass_SelectionImage', selector: '[id$="-img"]' },
        { id: 'selectionPlaceholder', labelKey: 'ComponentClass_SelectionPlaceholder', selector: '[id$="-placeholder"]' },
        { id: 'selectionTitle', labelKey: 'ComponentClass_SelectionTitle', selector: '.list-view-selection-title' },
        { id: 'selectionDescription', labelKey: 'ComponentClass_SelectionDescription', selector: '.list-view-selection-description' }
    ],
    'ComboBox.MultiSelect': [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: '.k-multiselect' },
        { id: 'selectedTag', labelKey: 'ComponentClass_SelectedTag', selector: '.k-chip' },
        { id: 'input', labelKey: 'ComponentClass_Input', selector: '.k-input-inner' },
        { id: 'dropdownButton', labelKey: 'ComponentClass_DropdownButton', selector: '.k-input-button' },
        { id: 'listItem', labelKey: 'ComponentClass_ListItem', selector: '.k-list-item' }
    ],
    'ComboBox.TreeView': [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: '.k-dropdowntree' },
        { id: 'input', labelKey: 'ComponentClass_Input', selector: '.k-input-inner' },
        { id: 'dropdownButton', labelKey: 'ComponentClass_DropdownButton', selector: '.k-input-button' },
        { id: 'treeItem', labelKey: 'ComponentClass_TreeItem', selector: '.k-treeview-item' }
    ],
    'ComboBox.RadioButton': [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: 'control' },
        { id: 'radioOption', labelKey: 'ComponentClass_RadioOption', selector: '.form-check' },
        { id: 'radioInput', labelKey: 'ComponentClass_RadioInput', selector: '.form-check-input' },
        { id: 'radioLabel', labelKey: 'ComponentClass_RadioLabel', selector: '.form-check-label' }
    ],
    'ComboBox.MultiSelectCheckBox': [
        { id: 'control', labelKey: 'ComponentClass_ComboBox', selector: 'control' },
        { id: 'checkOption', labelKey: 'ComponentClass_RadioOption', selector: '.form-check' },
        { id: 'checkInput', labelKey: 'ComponentClass_RadioInput', selector: '.form-check-input' },
        { id: 'checkLabel', labelKey: 'ComponentClass_RadioLabel', selector: '.form-check-label' }
    ],
    'GeomPicker.ModalMap': [
        { id: 'control', labelKey: 'ComponentClass_Input', selector: 'control' },
        { id: 'mapButton', labelKey: 'ComponentClass_MapButton', selector: '[id$="-action"]' }
    ],
    'GeomPicker.MapView': [
        { id: 'control', labelKey: 'ComponentClass_MapControl', selector: 'control' },
        { id: 'map', labelKey: 'ComponentClass_Map', selector: '.xp-map-container' }
    ]
};

export function getFieldComponents(item) {
    const ctlType = item != null ? item.CtlType : null;
    if (ctlType == null || CONTROL_COMPONENTS[ctlType] == null) {
        return COMMON_COMPONENTS;
    }

    const subtype = item.CtlProps != null ? item.CtlProps.CtlSubType : null;
    const subtypeComponents = subtype != null ? SUBTYPE_COMPONENTS[ctlType + '.' + subtype] : null;
    // Pentru Checkbox și Switch eticheta este inline, dar rămâne componentă distinctă în catalog.
    return COMMON_COMPONENTS.concat(subtypeComponents != null ? subtypeComponents : CONTROL_COMPONENTS[ctlType]);
}

export function parseComponentClasses(value) {
    if (value == null || typeof value != 'string') {
        return [];
    }

    return Array.from(new Set(value.trim().split(/\s+/).filter(Boolean)));
}

export function hasComponentClasses(componentClasses) {
    if (componentClasses == null || typeof componentClasses != 'object') {
        return false;
    }

    return Object.keys(componentClasses).some(key => parseComponentClasses(componentClasses[key]).length > 0);
}

export function getFieldComponentTargets(item, component) {
    const root = document.getElementById(item.UniqueClientId);
    const wrapper = document.getElementById(item.UniqueClientId + '-wrapper');
    if (root == null || wrapper == null) {
        return { targets: [], widget: null };
    }

    let targets = [];
    let widget = $(root).data('kendoComboBox') || $(root).data('kendoMultiSelect') || $(root).data('kendoDropDownTree');
    switch (component.selector) {
        case 'wrapper': targets = [wrapper]; break;
        case 'labelRow': targets = Array.from(wrapper.querySelectorAll('.xp-control-label-row, .xp-checkbox-row'));
            break;
        case 'label': targets = Array.from(wrapper.querySelectorAll('label.form-label, label.form-check-label'))
            .filter(target => !root.contains(target)); break;
        case 'labelActions': targets = Array.from(wrapper.querySelectorAll('.xp-control-label-row > .xp-control-actions, .xp-checkbox-row > .xp-control-actions'));
            break;
        case 'controlActions': targets = Array.from(wrapper.querySelectorAll('.xp-control-input-row > .xp-control-actions, .xp-checkbox-row > .xp-control-actions'));
            break;
        case 'controlRow': targets = Array.from(wrapper.querySelectorAll('.xp-control-input-row, .xp-checkbox-row'));
            break;
        case 'description': targets = Array.from(wrapper.querySelectorAll('.form-field-description')); break;
        case 'validation': {
            const validation = document.getElementById(item.UniqueClientId + '-validation');
            targets = validation != null ? [validation] : [];
            break;
        }
        case 'control': targets = [root]; break;
        case 'switch': {
            const generatedSwitch = root.closest('.k-switch')
                || (root.parentElement != null ? root.parentElement.querySelector('.k-switch') : null);
            targets = generatedSwitch != null ? [generatedSwitch] : [root];
            break;
        }
        default: {
            targets = Array.from(wrapper.querySelectorAll(component.selector));
            // Popup-urile Kendo pot fi atașate în afara wrapperului câmpului.
            const popupRoot = widget != null && widget.popup != null && widget.popup.element != null
                ? widget.popup.element[0] : null;
            if (popupRoot != null && popupRoot !== wrapper) {
                targets = targets.concat(Array.from(popupRoot.querySelectorAll(component.selector)));
            }
            break;
        }
    }

    return { targets: Array.from(new Set(targets)), widget };
}

export function applyFieldComponentClasses(item) {
    if (item == null || item.CtlProps == null || item.CtlProps.ComponentClasses == null) {
        return;
    }

    const componentMap = new Map(getFieldComponents(item).map(component => [component.id, component]));
    Object.keys(item.CtlProps.ComponentClasses).forEach(componentId => {
        const component = componentMap.get(componentId);
        const classes = parseComponentClasses(item.CtlProps.ComponentClasses[componentId]);
        if (component == null || classes.length == 0) {
            return;
        }

        const resolved = getFieldComponentTargets(item, component);
        if (resolved.widget != null && !resolved.widget._xpComponentClassesBound) {
            resolved.widget._xpComponentClassesBound = true;
            resolved.widget.bind('dataBound', () => applyFieldComponentClasses(item));
            resolved.widget.bind('open', () => applyFieldComponentClasses(item));
        }
        resolved.targets.forEach(target => {
            classes.forEach(className => {
                try { target.classList.add(className); } catch (e) { /* ignoră tokenurile HTML invalide */ }
            });
        });
    });
}
